// "Go back" on the static pages (FAQ, privacy, terms, legal notice). The CSP
// (`script-src 'self'`) blocks inline handlers, so the link is wired here: it
// steps back when the visitor came from this site, else follows its href.
import { canGoBack } from "./go-back-lib";

for (const link of document.querySelectorAll<HTMLAnchorElement>(
  "a[data-go-back]",
)) {
  link.addEventListener("click", (event) => {
    if (!canGoBack(document.referrer, window.location.origin)) return;
    event.preventDefault();
    history.back();
  });
}
